import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/auth";
import { AiOutlineClose } from "react-icons/ai";
import { IoLocationOutline, IoTrash } from "react-icons/io5";
import ReactLoading from "react-loading";
import { toast } from "react-toastify";
import config from "../../config";

export default function ModalAddIngressoAvulso({
  closeModal,
  vendedores,
  id_event,
  id_map,
  updateLocalIngressos,
  ingressos_avulsos,
  setIngressosAvulsos
}) {
  const { user } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    id_event,
    id_map,
mapCopyId: id_map,
    status: "disponivel",
    comprador: "",
    vendedor: "",
    vendedor_nome: "",

    lugares: [],
    qtd_lugares: 0,

    valor_total_locacao: 0,
    valor_recebido: 0,

    anotacoes_financeiras: "",
    formas_de_pagamento: [],
  });

  /* ======================================================
     FINANCEIRO
  ====================================================== */
  const recalcValorRecebido = (formas) => {
    const total = formas.reduce((s, f) => s + Number(f.valor || 0), 0);

    setFormData((prev) => ({
      ...prev,
      formas_de_pagamento: formas,
      valor_recebido: total,
    }));
  };

  const addFormaPagamento = () => {
    recalcValorRecebido([
      ...formData.formas_de_pagamento,
      {
        tipo: "",
        valor: 0,
        data_pagamento: new Date().toISOString().split("T")[0],
        observacao: "",
      },
    ]);
  };

  const updateFormaPagamento = (i, field, value) => {
    const clone = [...formData.formas_de_pagamento];
    clone[i][field] = value;
    recalcValorRecebido(clone);
  };

  const removeFormaPagamento = (i) => {
    const clone = [...formData.formas_de_pagamento];
    clone.splice(i, 1);
    recalcValorRecebido(clone);
  };

  /* ======================================================
     SALVAR
  ====================================================== */
  const addIngresso = async () => {
    try {
      setLoading(true);

      const res = await fetch(
        `${config.urlServer}/event/ingresso-avulso-add`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: user.email,
            token: user.token,
            data: formData,
          }),
        }
      );

      const json = await res.json();
      if (!res.ok) throw new Error(json.error || "Erro ao adicionar ingresso");

      toast.success("Ingresso adicionado com sucesso!");
    setIngressosAvulsos([...ingressos_avulsos, json?.ingresso]);

      closeModal();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  /* ======================================================
     RENDER
  ====================================================== */
  if (loading)
    return (
      <div className="flex justify-center items-center h-64">
        <ReactLoading type="spinningBubbles" color="#059669" />
      </div>
    );

  return (
    <div className="bg-white rounded-lg shadow-lg w-full max-w-[100vw] h-full overflow-hidden flex flex-col border border-gray-300">
      {/* HEADER */}
      <div className="sticky top-0 border-b border-gray-300 p-4 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <IoLocationOutline size={22} />
          <h2 className="text-lg font-semibold">Adicionar ingresso avulso</h2>
        </div>
        <button onClick={closeModal}>
          <AiOutlineClose size={22} />
        </button>
      </div>

      {/* CONTEÚDO */}
      <div className="flex-1 overflow-y-auto px-8 py-6 space-y-6">
        {/* STATUS */}
        <div className="flex gap-2">
          {["disponivel", "reservado", "vendido"].map((s) => (
            <button
              key={s}
              type="button"
              onClick={() => setFormData((p) => ({ ...p, status: s }))}
              className={`flex-1 py-1 rounded border font-medium ${
                formData.status === s
                  ? "bg-emerald-600 text-white border-emerald-600"
                  : "border-gray-300"
              }`}
            >
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>

        {/* VENDEDOR / COMPRADOR */}
        <div className="grid grid-cols-2 gap-4">
          <label className="flex flex-col text-sm">
            <span className="font-medium mb-1">Vendedor</span>
            <select
              value={formData.vendedor}
              onChange={(e) => {
                const v = vendedores.find((x) => x.email === e.target.value);
                setFormData({
                  ...formData,
                  vendedor: v?.email || "",
                  vendedor_nome: v?.nome || "",
                });
              }}
              className="border rounded p-2"
            >
              <option value="">Selecione...</option>
              {vendedores.map((v) => (
                <option key={v.email} value={v.email}>
                  {v.nome}
                </option>
              ))}
            </select>
          </label>

          <label className="flex flex-col text-sm">
            <span className="font-medium mb-1">Comprador</span>
            <input
              value={formData.comprador}
              onChange={(e) =>
                setFormData({ ...formData, comprador: e.target.value })
              }
              className="border rounded p-2"
            />
          </label>
        </div>

        {/* FORMAS DE PAGAMENTO */}
        <div className="border rounded p-4 bg-gray-50 space-y-2">
          <div className="flex justify-between">
            <span className="font-medium text-sm">Formas de pagamento</span>
            <button
              type="button"
              onClick={addFormaPagamento}
              className="text-xs bg-emerald-600 text-white px-3 py-1 rounded"
            >
              + Adicionar
            </button>
          </div>

          {formData.formas_de_pagamento.map((fp, i) => (
            <div
              key={i}
              className="grid grid-cols-6 gap-2 items-center bg-white border rounded p-2 text-xs"
            >
              <select
                value={fp.tipo}
                onChange={(e) =>
                  updateFormaPagamento(i, "tipo", e.target.value)
                }
                className="border rounded p-1"
              >
                <option value="">Tipo</option>
                <option value="dinheiro">Dinheiro</option>
                <option value="pix">Pix</option>
                <option value="cheque">Cheque</option>
                <option value="outro">Outro</option>
              </select>

              <input
                type="number"
                value={fp.valor}
                onChange={(e) =>
                  updateFormaPagamento(i, "valor", e.target.value)
                }
                className="border rounded p-1"
                placeholder="Valor"
              />

              <input
                type="date"
                value={fp.data_pagamento}
                onChange={(e) =>
                  updateFormaPagamento(i, "data_pagamento", e.target.value)
                }
                className="border rounded p-1"
              />

              <input
                value={fp.observacao}
                onChange={(e) =>
                  updateFormaPagamento(i, "observacao", e.target.value)
                }
                className="border rounded p-1 col-span-2"
                placeholder="Observação"
              />

              <button
                type="button"
                onClick={() => removeFormaPagamento(i)}
              >
                <IoTrash className="text-red-600" />
              </button>
            </div>
          ))}
        </div>

        {/* VALORES */}
        <div className="grid grid-cols-2 gap-4">
          <label className="flex flex-col text-sm">
            <span className="font-medium mb-1">Valor total</span>
            <input
              type="number"
              value={formData.valor_total_locacao}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  valor_total_locacao: e.target.value,
                })
              }
              className="border rounded p-2"
            />
          </label>

          <label className="flex flex-col text-sm">
            <span className="font-medium mb-1">Valor recebido</span>
            <input
              readOnly
              value={formData.valor_recebido}
              className="border rounded p-2 bg-gray-100"
            />
          </label>
        </div>

        {/* ANOTAÇÕES */}
        <label className="flex flex-col text-sm">
          <span className="font-medium mb-1">Anotações</span>
<textarea
  value={formData.anotacoes_financeiras}
  onChange={(e) =>
    setFormData({
      ...formData,
      anotacoes_financeiras: e.target.value,
    })
  }
className="!border-2 !border-gray-300"
style={{ border: "1px solid " }}

/>


        </label>
      </div>

      {/* FOOTER */}
      <div className="sticky bottom-0 border-t px-6 py-3 flex justify-end bg-white">
        <button
          onClick={addIngresso}
          className="bg-emerald-600 text-white px-8 py-2 rounded"
        >
          Salvar
        </button>
      </div>
    </div>
  );
}
